import React from 'react';
import styles from './Heading.module.scss';

const Features = () => {
  return (
    <div className={styles['features-wrapper']}>
      <div className={styles['header']}>
        <span className={styles['heading']}>
          <span className={styles['blue-text']}>
            Social Commerce Stack&nbsp;
          </span>
          to Support Startup Visions
        </span>
        <p className={styles['supporting-text']}>
        Interact with your customers on popular Social channels like Instagram, Facebook, WhatsApp, Telegram, Web Bots etc to generate leads, boost revenue and engage with your customers.
        </p>
        <br />
        <br />
        <div className={styles['animation-wrapper']}>
          <img src='socialcommerce.webp' alt='img' className={styles['img1']}/>
        </div>
      </div>

      <div className={styles['img2']}>
        <img src="group163.webp" alt='img' className={styles['img']} />
      </div>
    </div>
  );
};

export default Features;
